type LogoProps = {
  className?: string;
};

/**
 * Typographic wordmark: "Knit" in Pacifico (script), "in Time" in Space
 * Grotesk. Renders real text so the brand mark can be wrapped in any
 * heading element by the caller (e.g. `<h1><Logo /></h1>`) without an
 * SVG-with-aria-label dance. Pass a `text-{size}` class to control size.
 *
 * The illustrated SVG version of "Knit" still lives at
 * `src/assets/knit-wordmark.svg` and is used by the OG image generator.
 */
export function Logo({ className }: LogoProps) {
  return (
    <span className={className}>
      <span className="font-pacifico text-primary">Knit</span>
      <span className="font-display font-bold text-ink"> in Time</span>
    </span>
  );
}
